import { __ } from '../../../locales'

const DotsColorFilter = ({ inputs, onInputsChange }) => {
    return (
        <div className={'input-component'}>
        <label>{__('inputs.arrows_and_dots_color.label')}:</label>
        <select
            className="form-control"
            value={inputs.dotsArrowsColor}
            onInput={(ev) => onInputsChange('dotsArrowsColor', ev.target.value)}
        >
            <option value="4C5870" selected>{__('theme.dark_gray')}</option>
            <option value="B7BFCE">{__('theme.light_gray')}</option>
            <option value="FFFFFF">{__('theme.white')}</option>
        </select>
        </div>
    );
};

export default DotsColorFilter;
